<template>
  <div 
    :class="['wg-col','wg-xs-12','wg-sm-6','yb-reg-card', selected ? 'selected' : '']"
    @click="$emit('select-reg')">
  <div class="wg-row">
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-xl" style="font-weight:bold;">
        {{ $anm22.strLang(lang, 'Name', 'Nome') }}
      </div>
    </div>
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-l">
        {{ reg.name }}
      </div>
    </div>
  </div>
  <div class="wg-row">
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-xl" style="font-weight:bold;">
        {{ $anm22.strLang(lang, 'Surname', 'Cognome') }}
      </div>
    </div>
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-l">
        {{ reg.surname }}
      </div>
    </div>
  </div>
  <div class="wg-row">
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-xl" style="font-weight:bold;">
        {{ $anm22.strLang(lang, 'Umbrella', 'Ombrellone') }}
      </div>
    </div>
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-l">
        {{ reg.umbrella }}
      </div>
    </div>
  </div>
  <div class="wg-row">
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-xl" style="font-weight:bold;">
        {{ $anm22.strLang(lang, 'From', 'Arrivo') }}
      </div>
    </div>
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-l">
        {{ $moment.tz(reg.start_date, 'X', timezone).format('DD-MM-YYYY') }}
      </div>
    </div>
  </div>
  <div class="wg-row">
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-xl" style="font-weight:bold;">
        {{ $anm22.strLang(lang, 'To', 'Partenza') }}
      </div>
    </div>
    <div class="wg-col wg-xs-6">
      <div class="com-anm22-app-text-l">
        {{ $moment.tz(reg.end_date, 'X', timezone).format('DD-MM-YYYY') }}
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    reg: Object,
    timezone: String,
    selected: Boolean
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang
    })
  }
}
</script>

<style lang="scss" scoped>
.yb-reg-card {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width:300px;
  cursor:pointer;
  &.selected {
    box-shadow: 0 0 0 2px #2196f3;
  }
  &:hover {
    box-shadow: 0 0 0 2px #2196F3;
  }
}
</style>